module.exports = __webpack_public_path__ + "img/lg_ring_y_c_1_0@3x.7736bfe4.png";